import React from "react";
import PropTypes from "prop-types";
import "./index.css";
import warningIcon from "../../../../../assets/design-revamp-company/warning-icons/notice-warning-icon.svg";

const WarningBox = ({ title, message, onConfirm, onCancel, showCancel }) => {
  return (
    <div className="warning-box-overlay">
      <div className="warning-box">
        <div className="warning-box-header">
          <img
            src={warningIcon}
            alt="Notice Warning Icon"
            width={18}
            height={18}
          />
          <span className="warning-box-title">{title}</span>
        </div>
        <div className="warning-box-content">
          <p>{message}</p>
        </div>
        <div className="warning-box-actions">
          <button className="confirm-button" onClick={onConfirm}>
            Yes
          </button>
          {showCancel && (
            <button className="cancel-button" onClick={onCancel}>
              No
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

WarningBox.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
};

WarningBox.defaultProps = {
  title: "Notice",
  showCancel: true,
  onCancel: () => {},
};

export default WarningBox;
